import './button.scss';
import React from 'react';
import focusSettings from '../Focus/settings';
import Utils from '../../utils/Utils';

const defaultOrder = ['icon', 'text', 'color'];
const Button = ({ leftText, text, rightText, className, iconClassName, colorCode, style, onClick, onFocus, iconElement, order, focusable, focusDown, id }) => {
  const orderElements = order ? order : defaultOrder;
  const children = [];
  if (iconElement) {
    children["icon"] = iconElement
  } else {
    children["icon"] = iconClassName ? <i className={iconClassName}></i> : null;
  }
  children["color"] = colorCode ?
    <span className={`color-ball ${colorCode}`}></span>
    : null;
  className = className ? className : "";
  children["text"] = text;
  children["left-text"] = leftText;
  children["right-text"] = rightText;
  focusable = (typeof focusable === 'undefined') ? true : focusable;
  id = id ? id : String(`keyP-${Math.floor(10000 + Math.random() * 90000)}`)


  const handleMouseEnter = (e) => {
    Utils.handleMouseEnter(e)
  }

  return (
    <a
      id = {id}
      style={style}
      className={`${(focusable) ? focusSettings.className : ''} action ${className}`}
      onClick={onClick}
      onFocus={onFocus}
      data-sn-down={focusDown ? focusDown : undefined}
      onMouseEnter={() => handleMouseEnter(id)}
      href="javascript:void(0)"
      >
      {orderElements.map((item, index) => {
        const spanWithText = rightText !== null || children[item] !== null
          ? <span className={item + '-button'} key={index}>{children[item]}</span>
          : null;
        return spanWithText;
      })}
    </a>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.jsx